const english = {
    layout: {
        language: 'Language',
        menuItem1: 'Home',
        login: 'Sign In',
        logout: 'Sign Out',
    },
    buildings: {
        welcome: 'Your Buildings',
        overview: 'Select a building to view its apartments.',
        noBuildings: 'No buildings found.',
        backToBuildings: 'Back to buildings',
        apartments: 'Apartments',
    },
    signin: {
        title: 'Sign In',
        welcome_back: 'Welcome Back',
        signin_subtitle: 'Access your buildings portfolio dashboard.',
        username: 'Username or Email',
        username_placeholder: 'e.g., manager@email.com',
        password: 'Password',
        signin_button: 'SIGN IN',
        reset_link_short: 'Forgot Password?',
        reset_title: 'Reset password',
        reset_subtitle: 'Set a new password for your account.',
        reset_new_password: 'New password',
        reset_button: 'Reset password',
        reset_link: 'Forgot password? Reset here',
        reset_loading: 'Updating...',
        reset_success: 'Password updated successfully!',
        reset_error: 'Failed to reset password. Please try again.',
        reset_error_fill_fields: 'Please fill in username and new password.',
        back_to_signin: 'Back to sign in',
        loading: 'Loading...',
        branding: 'Multi-Apartment Building Manager',
        error_fill_fields: 'Please fill in all the required fields.',
        error_invalid_credentials: 'Invalid username or password. Please try again.',
        success_message: 'Logged in successfully!'
    },
    dashboard: {
        welcome: 'Welcome!',
        overview: 'Building overview at a glance.',
        apartments: 'Apartments',
        apartmentsEnergyOverview: 'Energy Overview',
        backToBuildings: 'Back to buildings',
        apartmentsCount: 'Apartments count',
        totalConsumption: 'Total consumption',
        address: 'Address',
        energyOverviewButton: 'Energy Overview',
        energyOverviewTooltip: 'Click here to see the energy consumption overview of your apartments',
        occupied: 'Occupied',
        notOccupied: 'Not occupied',
        appliancesNormal: 'Appliances work normally',
        estimatedCostPerStay: 'Estimated electricity cost per stay',
        estimatedCostPerDay: 'Estimated electricity cost per day',
        estimatedConsumptionLast7Days: 'Estimated consumption last 7 days',
        estimatedCostLast7Days: 'Estimated cost last 7 days',
        info: 'Details',
        currentBillingPeriod: 'Current Billing Period',
        last7Days: 'Last 7 days',
        electricityCost: 'Electricity Cost',
        consumedLast7Days: 'consumed (last 7 days)',
        occupancyRateThisMonth: 'Occupancy rate this month',
        electricityPrice: 'Electricity price',
        electricityPriceMoM: 'monthly',
        electricityPriceYoY: 'yearly',
        sortBy: 'Sort by',
        sortByCostPerStay: 'Cost per stay',
        sortByCostPerDay: 'Cost per day',
        sortByNextStay: 'Next stay',
        filterOccupied: 'Occupied',
        filterAll: 'All',
        floor: 'Floor',
        floors: 'Floors',
        floorAll: 'All',
        filterHighestOccupancy: 'Highest occupancy',
        filterLowestOccupancy: 'Lowest occupancy',
        sortByHighestConsumption: 'Highest consumption',
        sortByLowestConsumption: 'Lowest consumption',
        sortByHighestCost: 'Highest cost',
        sortByLowestCost: 'Lowest cost',
        featureNotImplemented: 'This feature is not implemented yet.',
        nextUpcomingStay: 'Next stay',
        currentStay: 'Current stay',
        currentStayDates: 'Current stay',
        nextStayDates: 'Next stay',
        lastStayDates: 'Last stay',
        inDays: 'in {count} days',
        moreAdvancedInsights: 'More advanced insights',
        checkInfo: 'Check info',
        copyShareLink: 'Copy share link',
        linkCopied: 'Link copied!',
        shareLinkError: 'Failed to create share link',
        estimatedCost: 'Estimated cost',
        refersToLastMonth: 'Refers to last month',
        chartDaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        allStatus: 'All Status',
        sortByNumber: 'Number',
        clickToCollapse: 'CLICK TO COLLAPSE',
        dailyConsumptionTrend: 'Daily Consumption Trend',
        lastMonth: 'Last Month',
        currentMonth: 'Current Month',
        custom: 'Custom',
        detailedCostBreakdown: 'Detailed Cost Breakdown',
        costsAreEstimated: 'All costs shown are estimated.',
        totalEstimatedToPay: 'Total Estimated to Pay',
        viewPdfBill: 'View PDF Bill',
        allProperties: 'All Properties',
        currentSelectionLabel: 'Current Selection',
        allManagedProperties: 'All Managed Properties',
        buildingLabelSingular: 'building',
        buildingLabelPlural: 'buildings',
        buildingManagementIdLabel: 'Building Management ID',
        summaryBadge: 'Summary',
        activeBadge: 'Active',
        apartmentsCountDescriptionAll: 'Across all managed buildings',
        apartmentsCountDescriptionSelected: 'Within selected building',
        consumptionDescriptionAll: 'Aggregated monthly usage',
        consumptionDescriptionSelected: 'Selected building usage',
        estimatedCostDescriptionAll: 'Estimated billing for all properties',
        estimatedCostDescriptionSelected: 'Estimated billing for selected building',
        apartmentsListSubtitle: 'Manage and monitor your apartments in one place.',
        editHouseButton: 'Edit',
        editHouseTitle: 'Edit House',
        editHouseSubtitle: 'Update house information and billing details',
        editHouseName: 'House Name',
        editHouseArea: 'Square meters',
        editHouseYear: 'Year of construction',
        editHouseEnergyClass: 'Energy Class',
        editHouseHeatingType: 'Heating Type',
        editHouseCoolingType: 'Cooling Type',
        editHousePlan: 'Electricity Plan',
        editHouseLoadingPlans: 'Loading plans...',
        editHouseNoPlan: 'No plan',
        editHousePlanSearch: 'Search plans...',
        editHouseNoPlansSearch: 'No plans found matching your search.',
        editHouseSelectedPlan: 'Selected Plan',
        editHousePlanWarning: 'Changing your electricity plan may affect billing calculations.',
        addDevicesButton: 'Add Devices',
        addDevicesTitle: 'Add Devices',
        addDevicesSubtitle: 'Search and add virtual devices for this apartment',
        addDevicesSearchPlaceholder: 'Search by brand or model...',
        addDevicesAllTypes: 'All types',
        addDevicesStartSearch: 'Start typing to search devices',
        addDevicesNoResults: 'No matching device models found',
        addDevicesCurrentVirtual: 'Current virtual devices',
        addDevicesNoVirtual: 'No virtual devices added yet',
        addDevicesDone: 'Done',
        addDevicesAdded: 'Device added',
        addDevicesAddError: 'Failed to add device',
        editHouseCancel: 'Cancel',
        editHouseSave: 'Save',
        usageDetailsTab: 'Usage Details',
        visitsManagementTab: 'Visits Management',
        visitsManagementPlaceholder: 'Visits management will be implemented here.',
        noVisitsPlanned: 'No visits are currently planned.',
        scheduleNewVisit: 'Schedule New Visit',
        arrival: 'Arrival',
        departure: 'Departure',
        confirmed: 'Confirmed',
        total: 'Total',
        none: 'None',
        editSelectedVisit: 'Edit selected visit',
        deleteSelectedVisit: 'Delete selected visit',
        selectedVisitLegend: 'Selected visit',
        otherVisitsLegend: 'Other visits',
        upcomingStays: 'Upcoming stays',
        currentStayConsumption: 'Current stay total consumption',
        visitConsumptionBreakdown: 'Visit consumption breakdown',
        visitConsumptionAvailableAfterEnd: 'Consumption details will be available after the first day of the visit.',
        visitEditTitle: 'Edit visit',
        visitEditSubtitle: 'Update visit details',
        visitCreateTitle: 'Create visit',
        visitCreateSubtitle: 'Create a new visit',
        visitCreateIcalOptional: 'Optional',
        visitEditStart: 'Start datetime',
        visitEditEnd: 'End datetime',
        visitEditActualCheckIn: 'Actual check-in datetime',
        visitEditActualCheckOut: 'Actual check-out datetime',
        visitEditPlatform: 'Platform',
        visitEditIcalUid: 'iCal UID',
        visitEditHouseId: 'House ID',
        visitEditInfo: 'Info',
        visitActionCancel: 'Cancel',
        visitActionSave: 'Save',
        visitActionCreate: 'Create',
        visitDeleteConfirmTitle: 'Delete confirmation',
        visitDeleteConfirmMessage: 'Are you sure you want to delete the selected visit?',
        visitActionDelete: 'Delete',
        editHouseSuccess: 'House updated successfully',
        editHouseLoadError: 'Failed to load house',
        editHouseSaveError: 'Failed to save house',
        editHouseValidationError: 'Name and address are required',
        editHouseAdditionalInfo: 'Additional House Info',
        editHouseMunicipalFees: 'Municipal fees per m²',
        editHouseMunicipalTaxes: 'Municipal taxes per m²',
        editHouseZonePrice: 'Zone Price',
        editHouseBuildingAge: 'Building Age',
        editHouseTapCoefficient: 'TAP Coefficient',
        editHouseSupplyPower: 'Agreed Supply Power (kW)',
        editHouseNightTariff: 'Night Tariff',
        editHouseYes: 'Yes',
        editHouseNo: 'No',
    },
    apartmentCard: {
        online: 'Online',
        last7DaysConsumption: 'Last 7 Days Consumption (kWh)',
        total: 'Total',
        estimatedCost: 'Estimated cost',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
    },
    deviceCard: {
        online: 'Online',
        last7DaysConsumption: 'Last 7 Days Consumption (kWh)',
        total: 'Total',
        room: 'Room',
        consumingMoreThanNormal: 'This device is consuming more than normal',
    },
    periodicConsumption: {
        title: 'Periodic Consumption',
        period: 'Period',
        lastDay: 'Last Day',
        lastWeek: 'Last Week',
        lastMonth: 'Last Month',
        customPeriod: 'Custom Period',
        startingDate: 'Starting Date',
        endingDate: 'Ending Date',
        retrieveData: 'Retrieve Data',
        error: 'Error',
        errorMessage: 'Something went wrong while fetching the data. Please try again later.',
        noDataAvailable: 'No consumption data available.',
        selectDatesAndRetrieve: 'Select dates and click Retrieve Data.',
        consumptionKwh: 'Consumption (kWh)',
        hoursOfTheDay: 'Hours of the Day',
        day: 'Day',
        averageLabelDay: 'Average consumption of the day (hourly)',
        averageLabelWeek: 'Average consumption of the week (daily)',
        averageLabelMonth: 'Average consumption of the month (daily)',
        averageLabelCustom: 'Average consumption in the requested period',
        daysFull: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    billBreakdown: {
        title: 'Bill Breakdown',
        electricityCost: 'Electricity Cost',
        commissionCharges: 'Commission Charges',
        regulationCharges: 'Regulation Charges',
        variousCharges: 'Various Charges',
        municipalTaxes: 'Municipal Taxes',
        ert: 'ERT',
        vat: 'VAT',
        totalCost: 'Total Cost',
        finalAmountToPay: 'Estimated final amount to pay',
        loadError: 'Failed to load bill breakdown',
    },
    apartmentAdmin: {
        title: 'Apartment administration',
        backToBuilding: 'Back to building',
        overview: 'Devices and consumption by room.',
        address: 'Address',
        totalConsumption: 'Total consumption',
        consumptionByRoom: 'Consumption by room',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        rooms: {
            livingRoom: 'Living Room',
            kitchen: 'Kitchen',
            bedroom: 'Bedroom',
            bathroom: 'Bathroom',
            other: 'Other',
        },
    },
};

const greek = {
    layout: {
        language: 'Γλώσσα',
        menuItem1: 'Αρχική',
        login: 'Σύνδεση',
        logout: 'Αποσύνδεση',
    },
    buildings: {
        welcome: 'Τα Κτίριά σας',
        overview: 'Επιλέξτε ένα κτίριο για να δείτε τα διαμερίσματά του.',
        noBuildings: 'Δεν βρέθηκαν κτίρια.',
        backToBuildings: 'Πίσω στα κτίρια',
        apartments: 'Διαμερίσματα',
    },
    signin: {
        title: 'Σύνδεση',
        welcome_back: 'Καλώς ήρθατε ξανά',
        signin_subtitle: 'Αποκτήστε πρόσβαση στο χαρτοφυλάκιο των κτιρίων σας.',
        username: 'Όνομα χρήστη ή Email',
        username_placeholder: 'π.χ. manager@email.com',
        password: 'Κωδικός',
        signin_button: 'ΣΥΝΔΕΣΗ',
        reset_link_short: 'Ξεχάσατε κωδικό;',
        reset_title: 'Επαναφορά κωδικού',
        reset_subtitle: 'Ορίστε νέο κωδικό για τον λογαριασμό σας.',
        reset_new_password: 'Νέος κωδικός',
        reset_button: 'Επαναφορά κωδικού',
        reset_link: 'Ξεχάσατε κωδικό; Επαναφορά εδώ',
        reset_loading: 'Ενημέρωση...',
        reset_success: 'Ο κωδικός ενημερώθηκε επιτυχώς!',
        reset_error: 'Αποτυχία επαναφοράς κωδικού. Παρακαλώ δοκιμάστε ξανά.',
        reset_error_fill_fields: 'Παρακαλώ συμπληρώστε όνομα χρήστη και νέο κωδικό.',
        back_to_signin: 'Πίσω στη σύνδεση',
        loading: 'Φόρτωση...',
        branding: 'Διαχειριστής Πολυκατοικιών',
        error_fill_fields: 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία.',
        error_invalid_credentials: 'Μη έγκυρος χρήστης ή κωδικός. Παρακαλώ δοκιμάστε ξανά.',
        success_message: 'Συνδεθήκατε επιτυχώς!'
    },
    dashboard: {
        welcome: 'Καλώς ήρθατε!',
        overview: 'Επισκόπηση κτιρίου με μια ματιά.',
        backToBuildings: 'Πίσω στα κτίρια',
        apartments: 'Διαμερίσματα',
        apartmentsEnergyOverview: 'Ενεργειακή διαχείριση διαμερισμάτων',
        apartmentsCount: 'Πλήθος Διαμερισμάτων',
        totalConsumption: 'Συνολική κατανάλωση',
        address: 'Διεύθυνση',
        energyOverviewButton: 'Ενεργειακή Διαχείριση',
        energyOverviewTooltip: 'Πατήστε εδώ για να δείτε την ενεργειακή κατανάλωση όλων των διαμερισμάτων σας',
        occupied: 'Κατειλημμένο',
        notOccupied: 'Ελεύθερο',
        appliancesNormal: 'Οι συσκευές λειτουργούν κανονικά',
        estimatedCostPerStay: 'Εκτιμώμενο κόστος ηλεκτρικού ανά διαμονή',
        estimatedCostPerDay: 'Εκτιμώμενο κόστος ηλεκτρικού ανά ημέρα',
        estimatedConsumptionLast7Days: 'Εκτιμώμενη κατανάλωση τελευταίων 7 ημερών',
        estimatedCostLast7Days: 'Εκτιμώμενο κόστος τελευταίων 7 ημερών',
        info: 'Πιο αναλυτικά',
        currentBillingPeriod: 'Τρέχουσα περίοδος χρέωσης',
        last7Days: 'Τελευταίες 7 ημέρες',
        electricityCost: 'Κόστος ηλεκτρικού',
        consumedLast7Days: 'κατανάλωση (τελευταίες 7 ημέρες)',
        occupancyRateThisMonth: 'Ποσοστό πληρότητας αυτόν τον μήνα',
        electricityPrice: 'Τιμή ηλεκτρικού ρεύματος',
        electricityPriceMoM: 'μηνιαία',
        electricityPriceYoY: 'ετήσια',
        sortBy: 'Ταξινόμηση',
        sortByCostPerStay: 'Κόστος ανά διαμονή',
        sortByCostPerDay: 'Κόστος ανά ημέρα',
        sortByNextStay: 'Επόμενη διαμονή',
        filterOccupied: 'Κατειλημμένα',
        filterAll: 'Όλα',
        floor: 'Όροφος',
        floors: 'Όροφοι',
        floorAll: 'Όλα',
        filterHighestOccupancy: 'Υψηλότερη πληρότητα',
        filterLowestOccupancy: 'Χαμηλότερη πληρότητα',
        sortByHighestConsumption: 'Υψηλότερη κατανάλωση',
        sortByLowestConsumption: 'Χαμηλότερη κατανάλωση',
        sortByHighestCost: 'Υψηλότερο κόστος',
        sortByLowestCost: 'Χαμηλότερο κόστος',
        featureNotImplemented: 'Αυτή η λειτουργία δεν έχει υλοποιηθεί ακόμα.',
        nextUpcomingStay: 'Επόμενη διαμονή',
        currentStay: 'Τρέχουσα διαμονή',
        currentStayDates: 'Τρέχουσα διαμονή',
        nextStayDates: 'Επόμενη διαμονή',
        lastStayDates: 'Τελευταία διαμονή',
        inDays: 'σε {count} ημέρες',
        moreAdvancedInsights: 'Περισσότερα στοιχεία',
        checkInfo: 'Λεπτομέρειες',
        copyShareLink: 'Αντιγραφή συνδέσμου',
        linkCopied: 'Ο σύνδεσμος αντιγράφηκε!',
        shareLinkError: 'Αποτυχία δημιουργίας συνδέσμου',
        estimatedCost: 'Εκτιμώμενο κόστος',
        refersToLastMonth: 'Αφορά τον τρέχοντα μήνα',
        chartDaysShort: ['Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'],
        allStatus: 'Όλη η κατάσταση',
        sortByNumber: 'Αριθμός',
        clickToCollapse: 'ΚΛΙΚ ΓΙΑ ΣΥΜΠΤΥΞΗ',
        dailyConsumptionTrend: 'Τάση ημερήσιας κατανάλωσης',
        lastMonth: 'Τελευταίος μήνας',
        currentMonth: 'Τρέχων μήνας',
        custom: 'Προσαρμογή',
        detailedCostBreakdown: 'Ανάλυση κόστους',
        costsAreEstimated: 'Όλα τα εμφανιζόμενα κόστη είναι εκτιμήσεις.',
        totalEstimatedToPay: 'Συνολικό εκτιμώμενο κόστος',
        viewPdfBill: 'Προβολή PDF λογαριασμού',
        allProperties: 'ΟΛΑ ΤΑ ΑΚΙΝΗΤΑ',
        currentSelectionLabel: 'ΤΡΕΧΟΥΣΑ ΕΠΙΛΟΓΗ',
        allManagedProperties: 'Όλα τα ακίνητα',
        buildingLabelSingular: 'κτίριο',
        buildingLabelPlural: 'κτίρια',
        buildingManagementIdLabel: 'Building Management ID',
        summaryBadge: 'Σύνοψη',
        activeBadge: 'Ενεργό',
        apartmentsCountDescriptionAll: 'Σε όλα τα διαχειριζόμενα ακίνητα',
        apartmentsCountDescriptionSelected: 'Στο επιλεγμένο κτίριο',
        consumptionDescriptionAll: 'Συγκεντρωτική μηνιαία κατανάλωση',
        consumptionDescriptionSelected: 'Κατανάλωση επιλεγμένου κτιρίου',
        estimatedCostDescriptionAll: 'Εκτιμώμενο κόστος για όλα τα ακίνητα',
        estimatedCostDescriptionSelected: 'Εκτιμώμενο κόστος για το επιλεγμένο κτίριο',
        apartmentsListSubtitle: 'Διαχειριστείτε και παρακολουθήστε τα διαμερίσματά σας σε ένα σημείο.',
        editHouseButton: 'Επεξεργασία',
        editHouseTitle: 'Επεξεργασία διαμερίσματος',
        editHouseSubtitle: 'Ενημερώστε τα στοιχεία διαμερίσματος και χρέωσης',
        editHouseName: 'Όνομα διαμερίσματος',
        editHouseArea: 'Τετραγωνικά μέτρα',
        editHouseYear: 'Έτος κατασκευής',
        editHouseEnergyClass: 'Ενεργειακή κλάση',
        editHouseHeatingType: 'Τύπος θέρμανσης',
        editHouseCoolingType: 'Τύπος ψύξης',
        editHousePlan: 'Πρόγραμμα ρεύματος',
        editHouseLoadingPlans: 'Φόρτωση προγραμμάτων...',
        editHouseNoPlan: 'Χωρίς πρόγραμμα',
        editHousePlanSearch: 'Αναζήτηση προγραμμάτων...',
        editHouseNoPlansSearch: 'Δεν βρέθηκαν προγράμματα για την αναζήτησή σας.',
        editHouseSelectedPlan: 'Επιλεγμένο πρόγραμμα',
        editHousePlanWarning: 'Η αλλαγή προγράμματος ρεύματος μπορεί να επηρεάσει τους υπολογισμούς χρέωσης.',
        addDevicesButton: 'Προσθήκη συσκευών',
        addDevicesTitle: 'Προσθήκη συσκευών',
        addDevicesSubtitle: 'Αναζήτηση και προσθήκη εικονικών συσκευών για αυτό το διαμέρισμα',
        addDevicesSearchPlaceholder: 'Αναζήτηση με μάρκα ή μοντέλο...',
        addDevicesAllTypes: 'Όλοι οι τύποι',
        addDevicesStartSearch: 'Ξεκινήστε να πληκτρολογείτε για αναζήτηση συσκευών',
        addDevicesNoResults: 'Δεν βρέθηκαν μοντέλα συσκευών',
        addDevicesCurrentVirtual: 'Τρέχουσες εικονικές συσκευές',
        addDevicesNoVirtual: 'Δεν έχουν προστεθεί εικονικές συσκευές',
        addDevicesDone: 'ΟΛΟΚΛΗΡΩΣΗ',
        addDevicesAdded: 'Η συσκευή προστέθηκε',
        addDevicesAddError: 'Αποτυχία προσθήκης συσκευής',
        editHouseCancel: 'ΑΚΥΡΩΣΗ',
        editHouseSave: 'ΑΠΟΘΗΚΕΥΣΗ',
        usageDetailsTab: 'Λεπτομέρειες Χρήσης',
        visitsManagementTab: 'Διαχείριση Κρατήσεων',
        visitsManagementPlaceholder: 'Η διαχείριση κρατήσεων θα υλοποιηθεί εδώ.',
        noVisitsPlanned: 'Δεν υπάρχουν προγραμματισμένες επισκέψεις αυτή τη στιγμή.',
        scheduleNewVisit: 'Νέα επίσκεψη',
        arrival: 'Άφιξη',
        departure: 'Αναχώρηση',
        confirmed: 'Επιβεβαιωμένες',
        total: 'Σύνολο',
        none: 'Καμία',
        editSelectedVisit: 'Επεξεργασία επιλεγμένης επίσκεψης',
        deleteSelectedVisit: 'Διαγραφή επιλεγμένης επίσκεψης',
        selectedVisitLegend: 'Επιλεγμένη επίσκεψη',
        otherVisitsLegend: 'Λοιπές επισκέψεις',
        upcomingStays: 'Επερχόμενες διαμονές',
        currentStayConsumption: 'Συνολική κατανάλωση τρέχουσας διαμονής',
        visitConsumptionBreakdown: 'Ανάλυση κατανάλωσης διαμονής',
        visitConsumptionAvailableAfterEnd: 'Τα στοιχεία κατανάλωσης θα είναι διαθέσιμα μετά την πρώτη ημέρα της διαμονής.',
        visitEditTitle: 'Επεξεργασία επίσκεψης',
        visitEditSubtitle: 'Ενημερώστε τα στοιχεία της επίσκεψης',
        visitCreateTitle: 'Δημιουργία επίσκεψης',
        visitCreateSubtitle: 'Δημιουργήστε μια νέα επίσκεψη',
        visitCreateIcalOptional: 'Προαιρετικό',
        visitEditStart: 'Ώρα έναρξης',
        visitEditEnd: 'Ώρα λήξης',
        visitEditActualCheckIn: 'Ώρα πραγματικής άφιξης',
        visitEditActualCheckOut: 'Ώρα πραγματικής αναχώρησης',
        visitEditPlatform: 'Πλατφόρμα',
        visitEditIcalUid: 'iCal UID',
        visitEditHouseId: 'ID διαμερίσματος',
        visitEditInfo: 'Πληροφορίες',
        visitActionCancel: 'ΑΚΥΡΟ',
        visitActionSave: 'ΑΠΟΘΗΚΕΥΣΗ',
        visitActionCreate: 'ΔΗΜΙΟΥΡΓΙΑ',
        visitDeleteConfirmTitle: 'Επιβεβαίωση διαγραφής',
        visitDeleteConfirmMessage: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την επιλεγμένη επίσκεψη;',
        visitActionDelete: 'Διαγραφή',
        editHouseSuccess: 'Το διαμέρισμα ενημερώθηκε επιτυχώς',
        editHouseLoadError: 'Αποτυχία φόρτωσης διαμερίσματος',
        editHouseSaveError: 'Αποτυχία αποθήκευσης διαμερίσματος',
        editHouseValidationError: 'Το όνομα και η διεύθυνση είναι υποχρεωτικά',
        editHouseAdditionalInfo: 'Πρόσθετα στοιχεία διαμερίσματος',
        editHouseMunicipalFees: 'Δημοτικά τέλη ανά τ.μ.',
        editHouseMunicipalTaxes: 'Δημοτικοί φόροι ανά τ.μ.',
        editHouseZonePrice: 'Τιμή ζώνης',
        editHouseBuildingAge: 'Παλαιότητα κτιρίου',
        editHouseTapCoefficient: 'Συντελεστής ΤΑΠ',
        editHouseSupplyPower: 'Συμφωνημένη ισχύς παροχής (kW)',
        editHouseNightTariff: 'Νυχτερινό τιμολόγιο',
        editHouseYes: 'Ναι',
        editHouseNo: 'Όχι',
    },
    apartmentCard: {
        online: 'Συνδεδεμένο',
        last7DaysConsumption: 'Κατανάλωση των τελευταίων 7 ημερών (kWh)',
        total: 'Σύνολο',
        estimatedCost: 'Εκτιμώμενο κόστος',
        checkIn: 'Άφιξη (Check-in)',
        checkOut: 'Αποχώρηση (Check-out)',
    },
    deviceCard: {
        online: 'Συνδεδεμένο',
        last7DaysConsumption: 'Κατανάλωση των τελευταίων 7 ημερών (kWh)',
        total: 'Σύνολο:',
        room: 'Δωμάτιο',
        consumingMoreThanNormal: 'Αυτή η συσκευή καταναλώνει περισσότερο από το φυσιολογικό',
    },
    periodicConsumption: {
        title: 'Περιοδική κατανάλωση',
        period: 'Περίοδος',
        lastDay: 'Τελευταία ημέρα',
        lastWeek: 'Τελευταία εβδομάδα',
        lastMonth: 'Τελευταίος μήνας',
        customPeriod: 'Προσαρμοσμένη περίοδος',
        startingDate: 'Ημερομηνία έναρξης',
        endingDate: 'Ημερομηνία λήξης',
        retrieveData: 'ΦΟΡΤΩΣΗ ΔΕΔΟΜΕΝΩΝ',
        error: 'Σφάλμα',
        errorMessage: 'Κάτι πήγε στραβά κατά τη φόρτωση των δεδομένων. Παρακαλώ δοκιμάστε ξανά αργότερα.',
        noDataAvailable: 'Δεν υπάρχουν διαθέσιμα δεδομένα κατανάλωσης.',
        selectDatesAndRetrieve: 'Επιλέξτε ημερομηνίες και πατήστε φόρτωση δεδομένων.',
        consumptionKwh: 'Κατανάλωση (kWh)',
        hoursOfTheDay: 'Ώρες της ημέρας',
        day: 'Ημέρα',
        averageLabelDay: 'Μέση κατανάλωση της ημέρας (ωριαία)',
        averageLabelWeek: 'Μέση κατανάλωση της εβδομάδας (ημερήσια)',
        averageLabelMonth: 'Μέση κατανάλωση του μήνα (ημερήσια)',
        averageLabelCustom: 'Μέση κατανάλωση στην επιλεγμένη περίοδο',
        daysFull: ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'],
        daysShort: ['Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'],
    },
    billBreakdown: {
        title: 'Ανάλυση λογαριασμού',
        electricityCost: 'Κόστος ηλεκτρικού',
        commissionCharges: 'Χρεώσεις προμήθειας',
        regulationCharges: 'Ρυθμιζόμενες χρεώσεις',
        variousCharges: 'Διάφορες χρεώσεις',
        municipalTaxes: 'Δημοτικοί φόροι',
        ert: 'ΕΡΤ',
        vat: 'ΦΠΑ',
        totalCost: 'Συνολικό κόστος',
        finalAmountToPay: 'Εκτιμώμενο τελικό κόστος πληρωμής',
        loadError: 'Αποτυχία φόρτωσης ανάλυσης λογαριασμού',
    },
    apartmentAdmin: {
        title: 'Διαχείριση διαμερίσματος',
        backToBuilding: 'Πίσω στο κτίριο',
        overview: 'Συσκευές και κατανάλωση ανά δωμάτιο.',
        address: 'Διεύθυνση',
        totalConsumption: 'Συνολική κατανάλωση',
        consumptionByRoom: 'Κατανάλωση ανά δωμάτιο',
        checkIn: 'Άφιξη',
        checkOut: 'Αποχώρηση',
        rooms: {
            livingRoom: 'Καθιστικό',
            kitchen: 'Κουζίνα',
            bedroom: 'Υπνοδωμάτιο',
            bathroom: 'Μπάνιο',
            other: 'Άλλο',
        },
    },
};

export const multilingual = {
    en: english,
    gr: greek,
};